import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect, useRef } from 'react';
import { useTheme } from 'styled-components';
import Icons from '../../../Elements/Icons/index.js';
import { Input } from '../../../Form/Input/index.js';
export const AUTOFOCUS_WITHOUT_SCROLL = Object.freeze({ preventScroll: true });
export const Search = ({ onChange, onClear, value, autofocus = AUTOFOCUS_WITHOUT_SCROLL }) => {
    const theme = useTheme();
    const ref = useRef(null);
    useLayoutEffect(() => {
        if (autofocus) {
            ref.current?.focus({ preventScroll: typeof autofocus === 'object' ? autofocus.preventScroll : false });
        }
    }, [autofocus]);
    return (_jsx(Input, { placeholder: 'Search', icon: value ? (_jsx(Icons.Clear, { filled: true, size: 15, color: theme.colors.grey100_1, onClick: onClear })) : (_jsx(Icons.Search, { size: 15, color: theme.colors.grey100_1 })), onChange: onChange, isActionIcon: !!value, value: value, ref: ref, dataTestId: 'dropdown-search-input' }));
};
